import { Action } from '@ngrx/store';
import {
  BodySchemaData,
  BodySchemaEditingMode,
  BodySchemaGeneralPain,
  BodySchemaMouthPainLocation,
  BodySchemaPelvicPainLocation,
  BodySchemaZoneBasic
} from './body-schema.models';

export const enum BodySchemaActionTypes {
  LOAD_BODY_SCHEMA = '[BodySchema] Load body schema',
  LOAD_BODY_SCHEMA_FAILED = '[BodySchema] Load body schema failed',
  LOAD_BODY_SCHEMA_SUCCESS = '[BodySchema] Load body schema success',
  SAVE_BODY_SCHEMA = '[BodySchema] Save body schema',
  SAVE_BODY_SCHEMA_FAILED = '[BodySchema] Save body schema failed',
  SAVE_BODY_SCHEMA_SUCCESS = '[BodySchema] Save body schema success',
  EDIT_ZONE = '[BodySchema] Edit zone',
  UPDATE_ZOOM = '[BodySchema] Update zoom',
  SET_EDITING_MODE = '[BodySchema] Set editing mode',
  SET_GENERAL_PAIN = '[BodySchema] Set general pain',
  SET_MOUTH_PAIN_LOCATION = '[BodySchema] Set mouth pain location',
  SET_PELVIC_PAIN_LOCATION = '[BodySchema] Set pelvic pain location',
  SET_PAIN_ZONES_COMPLETED = '[BodySchema] Set pain zones completed',
  SWITCH_FACE = '[BodySchema] Switch face',
  RESET_BODY_SCHEMA = '[BodySchema] Reset body schema'
}

export class BodySchemaActionLoadBodySchema implements Action {
  readonly type = BodySchemaActionTypes.LOAD_BODY_SCHEMA;
}

export class BodySchemaActionLoadBodySchemaFailed implements Action {
  readonly type = BodySchemaActionTypes.LOAD_BODY_SCHEMA_FAILED;
}

export class BodySchemaActionLoadBodySchemaSuccess implements Action {
  readonly type = BodySchemaActionTypes.LOAD_BODY_SCHEMA_SUCCESS;
  constructor(public payload: BodySchemaData) {}
}

export class BodySchemaActionSaveBodySchema implements Action {
  readonly type = BodySchemaActionTypes.SAVE_BODY_SCHEMA;
}

export class BodySchemaActionSaveBodySchemaFailed implements Action {
  readonly type = BodySchemaActionTypes.SAVE_BODY_SCHEMA_FAILED;
}

export class BodySchemaActionSaveBodySchemaSuccess implements Action {
  readonly type = BodySchemaActionTypes.SAVE_BODY_SCHEMA_SUCCESS;
}

export class BodySchemaActionEditZone implements Action {
  readonly type = BodySchemaActionTypes.EDIT_ZONE;
  constructor(public payload: BodySchemaZoneBasic) {}
}

export class BodySchemaActionUpdateZoom implements Action {
  readonly type = BodySchemaActionTypes.UPDATE_ZOOM;
  constructor(public payload: number) {}
}

export class BodySchemaActionSetEditingMode implements Action {
  readonly type = BodySchemaActionTypes.SET_EDITING_MODE;
  constructor(public payload: BodySchemaEditingMode) {}
}

export class BodySchemaActionSetGeneralPain implements Action {
  readonly type = BodySchemaActionTypes.SET_GENERAL_PAIN;
  constructor(public payload: Array<BodySchemaGeneralPain>) {}
}

export class BodySchemaActionSetMouthPainLocation implements Action {
  readonly type = BodySchemaActionTypes.SET_MOUTH_PAIN_LOCATION;
  constructor(public payload: Array<BodySchemaMouthPainLocation>) {}
}

export class BodySchemaActionSetPelvicPainLocation implements Action {
  readonly type = BodySchemaActionTypes.SET_PELVIC_PAIN_LOCATION;
  constructor(public payload: Array<BodySchemaPelvicPainLocation>) {}
}

export class BodySchemaActionSwitchFace implements Action {
  readonly type = BodySchemaActionTypes.SWITCH_FACE;
}

export class BodySchemaActionSetPainZonesCompleted implements Action {
  readonly type = BodySchemaActionTypes.SET_PAIN_ZONES_COMPLETED;
}

export class BodySchemaActionResetBodySchema implements Action {
  readonly type = BodySchemaActionTypes.RESET_BODY_SCHEMA;
}

export type BodySchemaActions =
  | BodySchemaActionLoadBodySchema
  | BodySchemaActionLoadBodySchemaFailed
  | BodySchemaActionLoadBodySchemaSuccess
  | BodySchemaActionSaveBodySchema
  | BodySchemaActionSaveBodySchemaFailed
  | BodySchemaActionSaveBodySchemaSuccess
  | BodySchemaActionEditZone
  | BodySchemaActionUpdateZoom
  | BodySchemaActionSetEditingMode
  | BodySchemaActionSetGeneralPain
  | BodySchemaActionSetMouthPainLocation
  | BodySchemaActionSetPelvicPainLocation
  | BodySchemaActionSwitchFace
  | BodySchemaActionSetPainZonesCompleted
  | BodySchemaActionResetBodySchema;
